import { client } from "./api.service";

export const getList = <T>(params: any) => client("canceledService").then(res => res.get<any, T>(
    "inspections",
    { params, authorization: true }
))

export const getItem = <T>(id: any) => client("canceledService").then(res => res.get<any, T>(
    `inspections/${id}`,
    { authorization: true }
))

export const saveComment = <T>(id: any, params: any) => client("canceledService").then(res => res.patch<any, T>(
    `inspections/${id}/comment`,
    params,
    {authorization: true}
))

export const getReport = <T>(params: any) => client("canceledService").then(res => res.get<any, T>(
    "export",
    { params, authorization: true }
))

export default { getList, getItem, saveComment}